(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallford-ar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wallford-ar-clip')) {
    customElements.define('wallford-ar-clip', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
        this.video.autoplay = !this.userPaused;
        this.inView = false;
        this.video.pause();
        this.video.controls = false;
        this.updateLabel = () => {
          const label = this.video.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
          this.button.textContent = label;
          this.button.setAttribute('aria-label', `${label}: ${this.button.dataset.stepTitle}`);
        };
        this.start = () => { this.video.muted = true; this.video.play().catch(this.updateLabel); };
        this.toggle = () => {
          this.userPaused = !this.video.paused;
          if (this.userPaused) this.video.pause(); else this.start();
        };
        this.onMotion = () => { if (this.motion.matches) { this.userPaused = true; this.video.pause(); } };
        this.onVisibility = () => { if (document.hidden) this.video.pause(); else if (this.inView && !this.userPaused) this.start(); };
        this.button.addEventListener('click', this.toggle);
        this.video.addEventListener('play', this.updateLabel);
        this.video.addEventListener('pause', this.updateLabel);
        this.video.addEventListener('ended', this.updateLabel);
        this.motion.addEventListener('change', this.onMotion);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (!this.inView) this.video.pause(); else if (!this.userPaused && !document.hidden) this.start();
        }, { threshold: 0.15 });
        this.observer.observe(this.video);
        this.button.hidden = false;
        this.updateLabel();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        this.button?.removeEventListener('click', this.toggle);
        this.video?.removeEventListener('play', this.updateLabel);
        this.video?.removeEventListener('pause', this.updateLabel);
        this.video?.removeEventListener('ended', this.updateLabel);
        this.motion?.removeEventListener('change', this.onMotion);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallford-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wallford-comparison')) {
    customElements.define('wallford-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const frame = this.querySelector('.wf-comparison__frame');
        const range = this.querySelector('input');
        const images = [...this.querySelectorAll('img')];
        if (!frame || !range || images.length !== 2) return;
        const update = () => {
          this.style.setProperty('--wf-split', `${range.value}%`);
          range.setAttribute('aria-valuetext', range.dataset.valueTemplate.replace('__PERCENT__', range.value));
        };
        const prepare = () => {
          if (!images.every(image => image.complete && image.naturalWidth > 0)) return;
          this.setAttribute('data-ready', '');
          range.disabled = false;
          update();
        };
        images.forEach(image => image.addEventListener('load', prepare, options));
        range.addEventListener('input', update, options);
        let pointerId = null;
        const move = event => {
          const box = frame.getBoundingClientRect();
          range.value = Math.round(Math.min(100, Math.max(0, (event.clientX - box.left) / box.width * 100)));
          update();
        };
        frame.addEventListener('pointerdown', event => {
          if (range.disabled || !event.isPrimary || event.button !== 0) return;
          pointerId = event.pointerId;
          frame.setPointerCapture(pointerId);
          range.focus({ preventScroll: true });
          move(event);
        }, options);
        frame.addEventListener('pointermove', event => {
          if (event.pointerId === pointerId) move(event);
        }, options);
        const end = () => { pointerId = null; };
        frame.addEventListener('pointerup', end, options);
        frame.addEventListener('pointercancel', end, options);
        frame.addEventListener('lostpointercapture', end, options);
        prepare();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallford-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wallford-hero-motion')) {
    customElements.define('wallford-hero-motion', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.closest('section').querySelector('[data-hero-toggle]');
        if (!this.video || !this.button) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
        this.inView = false;
        this.button.hidden = false;
        this.updateLabel = () => { this.button.textContent = this.video.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel; };
        this.start = () => { this.video.muted = true; this.video.play().catch(this.updateLabel); };
        this.onToggle = () => {
          this.userPaused = !this.video.paused;
          if (this.userPaused) this.video.pause(); else this.start();
        };
        this.onMotion = () => { if (this.motion.matches) { this.userPaused = true; this.video.pause(); } };
        this.onVisibility = () => { if (document.hidden) this.video.pause(); else if (this.inView && !this.userPaused) this.start(); };
        this.onPlaying = () => { this.setAttribute('data-ready', ''); this.updateLabel(); };
        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('pause', this.updateLabel);
        this.button.addEventListener('click', this.onToggle);
        this.motion.addEventListener('change', this.onMotion);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (!this.inView) this.video.pause(); else if (!this.userPaused && !document.hidden) this.start();
        }, { threshold: 0.1 });
        this.observer.observe(this);
        this.updateLabel();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        this.video?.removeEventListener('playing', this.onPlaying);
        this.video?.removeEventListener('pause', this.updateLabel);
        this.button?.removeEventListener('click', this.onToggle);
        this.motion?.removeEventListener('change', this.onMotion);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallford-montage-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wallford-montage-player')) {
    customElements.define('wallford-montage-player', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
        this.inView = false;
        this.automaticPause = false;
        this.video.muted = true;
        this.start = () => {
          if (this.inView && !document.hidden && !this.userPaused && !this.video.ended) {
            this.video.play().catch(() => {});
          }
        };
        this.stop = () => {
          if (!this.video.paused) {
            this.automaticPause = true;
            this.video.pause();
          }
        };
        this.onPause = () => {
          if (this.automaticPause) this.automaticPause = false;
          else if (!this.video.ended) this.userPaused = true;
        };
        this.onPlay = () => { this.userPaused = false; };
        this.onMotion = () => {
          if (this.motion.matches) {
            this.userPaused = true;
            this.stop();
          }
        };
        this.onVisibility = () => { if (document.hidden) this.stop(); else this.start(); };
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('play', this.onPlay);
        this.motion.addEventListener('change', this.onMotion);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
          if (this.inView) this.start(); else this.stop();
        }, { threshold: [0, 0.15] });
        this.observer.observe(this.video);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.stop?.();
        this.video?.removeEventListener('pause', this.onPause);
        this.video?.removeEventListener('play', this.onPlay);
        this.motion?.removeEventListener('change', this.onMotion);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallford-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wallford-motion')) {
    customElements.define('wallford-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || !('IntersectionObserver' in window)) return;
        this.controller = new AbortController();
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.seen = new WeakSet();
        this.targets = new Set();
        this.timers = new Map();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.reveal(entry.target);
          });
        }, { threshold: 0.01, rootMargin: '0px 0px -24px 0px' });

        const options = { signal: this.controller.signal };
        this.preference.addEventListener('change', () => {
          if (this.preference.matches) this.reset();
          else this.scan(document);
        }, options);
        document.addEventListener('shopify:section:load', (event) => this.scan(event.target), options);
        document.addEventListener('shopify:section:unload', (event) => {
          this.targets.forEach((target) => {
            if (event.target.contains(target)) this.clean(target);
          });
        }, options);
        document.addEventListener('focusin', (event) => {
          const target = event.target.closest('.wf-reveal-ready');
          if (target) this.clean(target);
        }, options);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.scan(document), { ...options, once: true });
        } else {
          this.scan(document);
        }
      }

      scan(scope) {
        if (this.preference.matches || window.Shopify?.designMode) return;
        const selectors = [
          '.collection__title h2',
          '.wf-design-stories__intro h2',
          '.wf-design-stories__copy h3',
          '.wf-design-stories__media',
          '.wf-ar__heading h2',
          '.wf-inspiration__intro h2',
          '.wf-inspiration__grid:not(.wf-inspiration__grid--extra) .wf-inspiration__media',
          '.wf-montage__copy h2',
          '.wf-story__image',
          '.wf-story__copy h2',
          '[id$="__wallford_contact_intro"] .rich-text__heading'
        ];
        scope.querySelectorAll(selectors.join(',')).forEach((target) => this.prepare(target, 0));
        scope.querySelectorAll('[id$="__featured_collection"] .product-grid > .grid__item').forEach((card, index) => {
          const image = card.querySelector('.card__media');
          if (image && index < 6) this.prepare(image, index * 40);
        });
      }

      prepare(target, delay) {
        if (this.seen.has(target) || !target.closest('#MainContent')) return;
        this.seen.add(target);
        const bounds = target.getBoundingClientRect();
        if (!bounds.width || !bounds.height || bounds.top < window.innerHeight + 40) return;
        this.targets.add(target);
        target.style.setProperty('--wf-reveal-delay', `${delay}ms`);
        target.classList.add('wf-reveal-ready');
        this.observer.observe(target);
      }

      reveal(target) {
        if (!this.targets.has(target)) return;
        this.observer.unobserve(target);
        target.classList.add('wf-reveal-visible');
        this.timers.set(target, window.setTimeout(() => this.clean(target), 800));
      }

      clean(target) {
        this.observer.unobserve(target);
        window.clearTimeout(this.timers.get(target));
        this.timers.delete(target);
        target.classList.remove('wf-reveal-ready', 'wf-reveal-visible');
        target.style.removeProperty('--wf-reveal-delay');
        this.targets.delete(target);
      }

      reset() {
        this.targets.forEach((target) => this.clean(target));
      }

      disconnectedCallback() {
        if (!this.controller) return;
        this.controller.abort();
        this.reset();
        this.observer.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
